import { AuthActionTypes } from '../../../enums/ActionEnums';
export const authActions = {
    getUserAuthState: () => ({
        type: AuthActionTypes.GET_USER_AUTH_STATE,
    }),
    updateUserAuthState: (payload) => ({
        type: AuthActionTypes.UPDATE_USER_AUTH_STATE,
        payload,
    }),
    createInitSocialAction: () => ({
        type: AuthActionTypes.INIT_SOCIAL,
    }),
    createLoadSocialSuccessAction: (payload) => ({
        type: AuthActionTypes.LOAD_SOCIAL_SUCCESS,
        payload,
    }),
    createSocialLoginAction: (payload) => ({
        type: AuthActionTypes.SOCIAL_LOGIN,
        payload,
    }),
    login: (payload) => ({
        type: AuthActionTypes.LOGIN,
        payload,
    }),
    registeredLogin: (payload) => ({
        type: AuthActionTypes.REGISTERED_LOGIN,
        payload,
    }),
    loginSuccess: (payload) => ({
        type: AuthActionTypes.LOGIN_SUCCESS,
        payload,
    }),
    loginFail: (payload) => ({
        type: AuthActionTypes.LOGIN_FAIL,
        payload,
    }),
    logout: () => ({
        type: AuthActionTypes.LOGOUT,
    }),
    logoutSuccess: () => ({
        type: AuthActionTypes.LOGOUT_SUCCESS,
    }),
    resetError: () => ({
        type: AuthActionTypes.RESET_ERROR,
    }),
    createResetCredentialsAction: (email) => ({
        type: AuthActionTypes.RESET_PASSWORD,
        payload: email,
    }),
    createResetCredentialsErrorAction: (message) => ({
        type: AuthActionTypes.RESET_PASSWORD_ERROR,
        payload: message,
    }),
    createResetCredentialsSuccessAction: (message) => ({
        type: AuthActionTypes.RESET_PASSWORD_SUCCESS,
        payload: message,
    }),
    createLoginGuestAction: (userName, exploreMoreCardNumber, customerUUID) => ({
        type: AuthActionTypes.LOGIN_GUEST,
        payload: { userName, exploreMoreCardNumber, customerUUID },
    }),
    createLoginGuestSuccessAction: () => ({
        type: AuthActionTypes.LOGIN_GUEST_SUCCESS,
    }),
    createLoginGuestFailAction: (payload) => ({
        type: AuthActionTypes.LOGIN_GUEST_FAIL,
        payload,
    }),
    createLoginReturnGuestAction: (payload) => ({
        type: AuthActionTypes.LOGIN_RETURN_GUEST,
        payload,
    }),
    createLoginReturnGuestSuccessAction: () => ({
        type: AuthActionTypes.LOGIN_RETURN_GUEST_SUCCESS,
    }),
    createLoginReturnGuestFailAction: (payload) => ({
        type: AuthActionTypes.LOGIN_RETURN_GUEST_FAIL,
        payload,
    }),
};
